"use client"

import * as React from "react"

import { api, type Skill } from "@/lib/api"
import { useAuth } from "@/lib/auth"
import { PageShell } from "@/components/page-shell"
import { WorkflowsList } from "@/components/workflows-list"

export default function WorkflowsPage() {
  const { user, loading: authLoading } = useAuth()
  const [skills, setSkills] = React.useState<Skill[]>([])

  // The builder needs the skill catalogue to render its picker.
  React.useEffect(() => {
    if (authLoading || !user) return
    void api.skills().then((r) => setSkills(r.data?.skills ?? []))
  }, [authLoading, user])

  return (
    <PageShell crumbs={[{ label: "Workflows" }]}>
      <WorkflowsList skills={skills} />
    </PageShell>
  )
}
